// Olyan szekció, ami az entitás LÉTREHOZÁSA UTÁN válik elérhetővé (kapcsolódó adat: fiókok, szolgáltatások,
// bankkártyák, számlázási profilok). Létrehozás-oldalon MEGJELENIK — így a felhasználó látja az ügyfél teljes
// hatókörét —, de zárolva: a kapcsolódó rekord a szülő nélkül nem hozható létre.
//
// MIÉRT megmutatjuk zárva, és nem rejtjük el: a régi CRM tabos szerkesztőjében (Alapadatok / Fiókok /
// Szolgáltatások / Dokumentumok + bankkártya-modál) a tabok LÉTREHOZÁSKOR IS látszottak. A rejtés elvenné
// azt az információt, hogy ezek egyáltalán léteznek — a zárolt, magyarázott állapot a bevett minta.
//
// A doboz maga a közös `SectionPlaceholder` (ugyanaz az alak, mint a szerkesztés-oldali ÜRES szekcióé), itt a
// `locked` ágon — a lakattal.
import { FormSection } from '@/components/shared/form-section';
import { SectionPlaceholder, type SectionIcon } from '@/components/shared/section-placeholder';

export function LockedSection({
  icon,
  title,
  description,
  hint,
}: {
  /** A szekció tárgyát jelző ikon (a nav-ikonnal egyező, hogy felismerhető legyen). */
  icon: SectionIcon;
  title: string;
  /** Mit tartalmaz majd a szekció — a hatókör magyarázata. */
  description?: string;
  /** Miért zárolt + mikor oldódik fel. */
  hint: string;
}): JSX.Element {
  return (
    <FormSection title={title} description={description}>
      <SectionPlaceholder icon={icon} locked>
        {hint}
      </SectionPlaceholder>
    </FormSection>
  );
}
